import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Employee from '../../../containers/Dashboard/Department/Employee/Employee'

const RoomSelectFilterItem = props => {
  const {type, employee, color, selected} = props
  const {button, border, text} = color

  const doSelect = evt => {
    props.onItemClick({type, item: props, evt})
  }
  return (
    <div>
      {employee ? (
        <StyledEmployee onClick={doSelect} selected={selected}>
          <Employee employee={employee} />
        </StyledEmployee>
      ) : (
        <StyledContainer
          buttonColor={button}
          borderColor={border || text}
          selected={selected}
        >
          <StyledItem textColor={text} onClick={doSelect}>
            {props.label}
          </StyledItem>
        </StyledContainer>
      )}
    </div>
  )
}

RoomSelectFilterItem.propTypes = {
  type: PropTypes.string.isRequired
}

RoomSelectFilterItem.defaultProps = {
  color: {
    button: '#F7F8FC',
    text: 'black',
    border: '#E6E8F0'
  }
}

export default RoomSelectFilterItem

const StyledItem = styled.div`
  padding-left: 20px;
  font-style: normal;
  font-weight: 500;
  font-size: 10pt;
  color: ${props => props.textColor};
`

const StyledContainer = styled.div`
  width: 100%;
  height: 39px;
  margin-bottom: 13px;
  border-radius: 4px;
  cursor: pointer;

  display: grid;
  box-sizing: border-box;
  grid-template-columns: 250px 1fr;
  grid-template-rows: auto;
  align-content: center;

  background-color: ${props => props.buttonColor};
  border-left: 11px solid ${props => props.borderColor};

  box-shadow: ${props =>
    props.selected ? '0 1px 6px 0 rgba(51, 149, 254, 0.38)' : 'none'};
  ${StyledItem} {
    color: ${props => (props.selected ? '#3395fe' : props.textColor)};
    font-weight: ${props => (props.selected ? '600' : '500')};
  }
`

const StyledEmployee = styled.div`
  cursor: pointer;
  box-shadow: ${props =>
    props.selected ? '0 1px 6px 0 rgba(51, 149, 254, 0.38)' : 'none'};
`
